module.exports = "<p>support works!</p>\n"